export default "__VITE_ASSET__DolrIQve__"